import { render, staticRenderFns } from "./PaymentAccount.vue?vue&type=template&id=044c8e15&scoped=true&"
import script from "./PaymentAccount.vue?vue&type=script&lang=js&"
export * from "./PaymentAccount.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAccount.vue?vue&type=style&index=0&id=044c8e15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c8e15",
  null
  
)

export default component.exports